import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurationService } from '../../services/configuration/configuration.service';

@Pipe({
  name: 'orderStatus'
})
export class OrderStatusPipe implements PipeTransform {
  constructor(private service: ConfigurationService) {}

  transform(statusId: number): string {
    const item = this.service.orderStatus.find(
      (status) => status.id === statusId
    );
    return item ? item.name : '';
  }
}
